import { z } from "zod";

const nullableString = z.string().nullable();

const LiveHeaderSchema = z.object({
  venue_account_id: z.string(),
  venue_name: z.string(),
  account_ref: z.string(),
  enabled: z.boolean(),
  source: z.string(),
  server_time: nullableString,
  fetched_at: z.string(),
  staleness_seconds: z.number(),
});

const LivePositionRowSchema = z.object({
  symbol: z.string(),
  dex: z.string(),
  venue_symbol: nullableString,
  instrument_name: nullableString,
  key_status: z.enum(["mapped", "unmapped", "mismatch", "duplicate"]),
  key_reason: nullableString,
  size: nullableString,
  entry_price: nullableString,
  mark: nullableString,
  unrealized_pnl: nullableString,
  liquidation_price: nullableString,
  margin_mode: nullableString,
  leverage: nullableString,
  margin_used: nullableString,
  funding_accrued: nullableString,
});

const LiveCollateralRowSchema = z.object({
  asset: z.string(),
  posted: nullableString,
  free: nullableString,
  used_margin: nullableString,
  account_equity: nullableString,
});

const LivePositionsSchema = LiveHeaderSchema.extend({
  rows: z.array(LivePositionRowSchema),
});

const LiveCollateralSchema = LiveHeaderSchema.extend({
  account_equity: nullableString,
  used_margin: nullableString,
  available: nullableString,
  summary_note: nullableString,
  rows: z.array(LiveCollateralRowSchema),
});

type LivePositions = z.infer<typeof LivePositionsSchema>;
type LiveCollateral = z.infer<typeof LiveCollateralSchema>;
type LivePositionRow = z.infer<typeof LivePositionRowSchema>;
type LiveCollateralRow = z.infer<typeof LiveCollateralRowSchema>;

export { LiveCollateralSchema, LivePositionsSchema };
export type { LiveCollateral, LiveCollateralRow, LivePositionRow, LivePositions };
